export default __webpack_public_path__ + "static/media/dn.232910c7.jpg";